export class Deferred<A> {
  resolve: (value: A) => void;
  reject:  (err: Error) => void;
  promise: Promise<A>;
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = value => {
        resolve(value);
        return this.promise;
      };
      this.reject = reason => {
        reject(reason);
        return this.promise;
      };
    });
  }
}
